const APP = {
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_PAGE_TOP_LOADER: "SET_PAGE_TOP_LOADER",
  SET_JWTOKEN: "SET_JWTOKEN",
  SET_ID_TOKEN: "SET_ID_TOKEN",
  SET_ACCESS_KEY: "SET_ACCESS_KEY",
  SET_USERNAME: "SET_USERNAME",
  SET_USER_EMAIL: "SET_USER_EMAIL",
  SET_DATE_RANGE: "SET_DATE_RANGE",
  SET_MIN_MAX_DATE_RANGE: "SET_MIN_MAX_DATE_RANGE",
  SET_PERIOD_TYPE: "SET_PERIOD_TYPE",
  SET_MISSION_ONLY: "SET_MISSION_ONLY",
  SET_NO_REPORT: "SET_NO_REPORT",
  GET_SEASON_DATA: "GET_SEASON_DATA",
  SET_SEASON_DATA: "SET_SEASON_DATA",
  SET_SELECTED_SEASON: "SET_SELECTED_SEASON",
  SET_SELECTED_SEASON_LABEL: "SET_SELECTED_SEASON_LABEL",
  SET_FILTER_DRAWER_STATE: "SET_FILTER_DRAWER_STATE",
  SET_FILTER_TYPE: "SET_FILTER_TYPE",
  SET_SELECTED_TAG: "SET_SELECTED_TAG",
  GET_MISSION_DATA: "GET_MISSION_DATA",
  SET_MISSION_DATA: "SET_MISSION_DATA",
  SET_SELECTED_MISSION: "SET_SELECTED_MISSION",
  SET_SELECTED_MISSION_LABEL: "SET_SELECTED_MISSION_LABEL",
  SET_TAG_SAVING_LOADER: "SET_TAG_SAVING_LOADER",
  GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME: "GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME",
  GET_SAVED_SELECTED_TAG_DATA_BY_EMAIL: "GET_SAVED_SELECTED_TAG_DATA_BY_EMAIL",
  SET_SAVED_SELECTED_TAG_DATA: "SET_SAVED_SELECTED_TAG_DATA",
  SET_SAVED_SELECTED_REPORT_TAG_DATA: "SET_SAVED_SELECTED_REPORT_TAG_DATA",
  SET_DRAWER_TAG_TIP: "SET_DRAWER_TAG_TIP",
  SET_COMMENT_SAVING_LOADER: "SET_COMMENT_SAVING_LOADER",
  SET_ASSET_COMMENT: "SET_ASSET_COMMENT",
  SET_SAVED_COMMENT_DATA: "SET_SAVED_COMMENT_DATA",
  RESET_STORE: "RESET_STORE",
  GET_SAVED_COMMENT_DATA_BY_FILENAME: "GET_SAVED_COMMENT_DATA_BY_FILENAME",
  SET_SELECTED_REPORT_TAG: "SET_SELECTED_REPORT_TAG",
  GET_SAVED_SELECTED_REPORT_TAG_DATA_BY_REPORT_ID: "GET_SAVED_SELECTED_REPORT_TAG_DATA_BY_REPORT_ID",
  GET_SAVED_SELECTED_REPORT_TAG_DATA_BY: "GET_SAVED_SELECTED_REPORT_TAG_DATA_BY",
  SET_SAVED_SELECTED_REPORT_TAG_DATA_BY: "SET_SAVED_SELECTED_REPORT_TAG_DATA_BY",
  SET_SELECTED_TAG_NTT: "SET_SELECTED_TAG_NTT",
  SET_SAVED_SELECTED_TAG_DATA_NTT: "SET_SAVED_SELECTED_TAG_DATA_NTT",
  GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_NTT: "GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_NTT",
  SET_SELECTED_TAG_HOKUDEN: "SET_SELECTED_TAG_HOKUDEN",
  SET_SAVED_SELECTED_TAG_DATA_HOKUDEN: "SET_SAVED_SELECTED_TAG_DATA_HOKUDEN",
  GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_HOKUDEN: "GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_HOKUDEN",
  SET_SAVED_COMMENT_DATA_HOKUDEN: "SET_SAVED_COMMENT_DATA_HOKUDEN",
  GET_SAVED_COMMENT_DATA_BY_FILENAME_HOKUDEN: "GET_SAVED_COMMENT_DATA_BY_FILENAME_HOKUDEN",
  SET_SELECTED_REPORT_STATUS: "SET_SELECTED_REPORT_STATUS",
  SET_SAVED_SELECTED_REPORT_STATUS_DATA: "SET_SAVED_SELECTED_REPORT_STATUS_DATA",
  GET_SAVED_SELECTED_REPORT_STATUS_DATA_BY_REPORT_ID: "GET_SAVED_SELECTED_REPORT_STATUS_DATA_BY_REPORT_ID",
  SET_REPORT_STATUS_SAVING_LOADER: "SET_REPORT_STATUS_SAVING_LOADER",
};

const HOME = {
  GET_TOTAL_STATS_DATA: "GET_TOTAL_STATS_DATA",
  SET_TOTAL_STATS_DATA: "SET_TOTAL_STATS_DATA",
  GET_HOME_IMAGE_DATA: "GET_HOME_IMAGE_DATA",
  SET_HOME_IMAGE_DATA: "SET_HOME_IMAGE_DATA",
  GET_HOME_IMAGE_DATA_NTT: "GET_HOME_IMAGE_DATA_NTT",
  SET_HOME_IMAGE_DATA_NTT: "SET_HOME_IMAGE_DATA_NTT",
  GET_HOME_IMAGE_DATA_HOKUDEN: "GET_HOME_IMAGE_DATA_HOKUDEN",
  SET_HOME_IMAGE_DATA_HOKUDEN: "SET_HOME_IMAGE_DATA_HOKUDEN",
  GET_HOME_MISSION_IMAGE_DATA: "GET_HOME_MISSION_IMAGE_DATA",
  SET_HOME_MISSION_IMAGE_DATA: "SET_HOME_MISSION_IMAGE_DATA",
  SET_TOTAL_IMAGE_COUNT: "SET_TOTAL_IMAGE_COUNT",
  SET_CURRENT_PAGE_NUMBER: "SET_CURRENT_PAGE_NUMBER",
  SET_FILTERED_TOTAL: "SET_FILTERED_TOTAL",
  SET_FILTER: "SET_FILTER",
  SET_FILTER_NTT: "SET_FILTER_NTT",
  SET_FILTER_HOKUDEN: "SET_FILTER_HOKUDEN",
  SET_HOKUDEN_OPTION_CITY: "SET_HOKUDEN_OPTION_CITY",
  SET_HOKUDEN_OPTION_BRANCH: "SET_HOKUDEN_OPTION_BRANCH",
};

const VIEWER = {
  GET_IMAGE_DATA_BY_FILENAME: "GET_IMAGE_DATA_BY_FILENAME",
  SET_IMAGE_DATA_BY_FILENAME: "SET_IMAGE_DATA_BY_FILENAME",
  SET_VIEWER_IMAGE_DATA: "SET_VIEWER_IMAGE_DATA",
  SET_VIEWER_IMAGE_DATA_EXTRA: "SET_VIEWER_IMAGE_DATA_EXTRA",
};

const IMAGE = {
  GET_ALL_IMAGE_DATA_BY_FILENAME: "GET_ALL_IMAGE_DATA_BY_FILENAME",
  SET_ALL_IMAGE_DATA_BY_FILENAME: "SET_ALL_IMAGE_DATA_BY_FILENAME",
};

const REPORT = {
  GET_REPORT_TOTAL_STATS_DATA: "GET_REPORT_TOTAL_STATS_DATA",
  SET_REPORT_TOTAL_STATS_DATA: "SET_REPORT_TOTAL_STATS_DATA",
  GET_REPORT_DATA: "GET_REPORT_DATA",
  SET_REPORT_DATA: "SET_REPORT_DATA",
  GET_REPORT_TAG_FILTER_DATA: "GET_REPORT_TAG_FILTER_DATA",
  SET_REPORT_TAG_FILTER_DATA: "SET_REPORT_TAG_FILTER_DATA",
  SET_REPORT_TOTAL_IMAGE_COUNT: "SET_REPORT_TOTAL_IMAGE_COUNT",
  SET_REPORT_CURRENT_PAGE_NUMBER: "SET_REPORT_CURRENT_PAGE_NUMBER",
  SET_REPORT_FILTERED_TOTAL: "SET_REPORT_FILTERED_TOTAL",
  SET_REPORT_FILTER: "SET_REPORT_FILTER",
  GET_DOWNLOAD_REPORT_DATA: "GET_DOWNLOAD_REPORT_DATA",
  GET_REMOVAL_REQUEST_DOWNLOAD_DATA: "GET_REMOVAL_REQUEST_DOWNLOAD_DATA",
  GET_BIRDNEST_REWARD_DOWNLOAD_DATA: "GET_BIRDNEST_REWARD_DOWNLOAD_DATA",
  SET_DOWNLOAD_REPORT_DATA: "SET_DOWNLOAD_REPORT_DATA",
  GET_DOWNLOAD_REPORT_DATA_NTT: "GET_DOWNLOAD_REPORT_DATA_NTT",
  SET_DOWNLOAD_REPORT_DATA_NTT: "SET_DOWNLOAD_REPORT_DATA_NTT",
  GET_DOWNLOAD_REPORT_DATA_HOKUDEN: "GET_DOWNLOAD_REPORT_DATA_HOKUDEN",
  SET_DOWNLOAD_REPORT_DATA_HOKUDEN: "SET_DOWNLOAD_REPORT_DATA_HOKUDEN",
  GET_IMAGE_DATA_BY_REPORT_ID: "GET_IMAGE_DATA_BY_REPORT_ID",
  SET_IMAGE_DATA_BY_REPORT_ID: "SET_IMAGE_DATA_BY_REPORT_ID",
  SET_IMAGE_DATA_BY_OTHER_USERS: "SET_IMAGE_DATA_BY_OTHER_USERS",
  SET_NO_IMAGE_DATA_BY_REPORT_ID: "SET_NO_IMAGE_DATA_BY_REPORT_ID",
  SET_REPORT_FILTER_NTT: "SET_REPORT_FILTER_NTT",
  GET_REPORT_DATA_NTT: "GET_REPORT_DATA_NTT",
  SET_REPORT_DATA_NTT: "SET_REPORT_DATA_NTT",
  SET_REPORT_TAG_FILTER_DATA_NTT: "SET_REPORT_TAG_FILTER_DATA_NTT",
  SET_REPORT_FILTER_HOKUDEN: "SET_REPORT_FILTER_HOKUDEN",
  GET_REPORT_DATA_HOKUDEN: "GET_REPORT_DATA_HOKUDEN",
  SET_REPORT_DATA_HOKUDEN: "SET_REPORT_DATA_HOKUDEN",
  SET_REPORT_TAG_FILTER_DATA_HOKUDEN: "SET_REPORT_TAG_FILTER_DATA_HOKUDEN",
  SET_HOKUDEN_REPORT_OPTION_CITY: "SET_HOKUDEN_REPORT_OPTION_CITY",
  SET_HOKUDEN_REPORT_OPTION_BRANCH: "SET_HOKUDEN_REPORT_OPTION_BRANCH",
  GET_REPORT_DATA_MISSION: "GET_REPORT_DATA_MISSION",
  SET_REPORT_DATA_MISSION: "SET_REPORT_DATA_MISSION",
  SET_REPORT_TAG_FILTER_DATA_MISSION: "SET_REPORT_TAG_FILTER_DATA_MISSION",
};

const PLOT = {
  GET_PLOT_DATA: "GET_PLOT_DATA",
  SET_PLOT_DATA: "SET_PLOT_DATA",
  SET_PLOT_LOADING: "SET_PLOT_LOADING",
  SET_PLOT_ERROR: "SET_PLOT_ERROR",
};

const PLOT_VIEWER = {
  GET_PLOT_IMAGE_DATA_BY_FILENAME: "GET_PLOT_IMAGE_DATA_BY_FILENAME",
  SET_PLOT_IMAGE_DATA_BY_FILENAME: "SET_PLOT_IMAGE_DATA_BY_FILENAME",
  SET_PLOT_VIEWER_IMAGE_DATA: "SET_PLOT_VIEWER_IMAGE_DATA",
  SET_PLOT_VIEWER_LOADING: "SET_PLOT_VIEWER_LOADING",
  SET_PLOT_VIEWER_ERROR: "SET_PLOT_VIEWER_ERROR",
};

const DOWNLOAD = {
  SET_TOTATL_FILES: "SET_TOTATL_FILES",
  SET_AREA_GROUP: "SET_AREA_GROUP",
  SET_FILTER_DOWNLOAD: "SET_FILTER_DOWNLOAD",
};

const ENDPOINT = {
  GET_DATA_API: "/api/data",
  GET_DATA_API_REPLICA: "/api/data-replica",
  GET_DATA_KPIDASH_API: "/api/data-kpidash",
  GET_DATA_SXI_PHOTO: "/photo",
  GET_DATA_SXI_PHOTO_BY_FILE: "/photo/filename",
};

export { APP, HOME, VIEWER, IMAGE, REPORT, PLOT, PLOT_VIEWER, DOWNLOAD, ENDPOINT };
